<template>
  <div class="layout-footer mt15">
    <div class="layout-footer-warp">
      <div class="jh">
        <img :src="jhimg" alt />
      </div>
      <div class="mt5">
        <div v-for="(item, i) in persondata" :key="i"><el-link :underline="false" :href="item.url">{{ item.title }}</el-link></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "layoutFooter",
  data() {
    return {
      persondata: [
        // {
        //   id: "xxxxx",
        //   title: "aaaa",
        //   url: "aaaa",
        // },
        // {
        //   id: "xxxxx",
        //   title: "aaaa",
        //   url: "aaaa",
        // },
        // {
        //   id: "xxxxx",
        //   title: "aaaa",
        //   url: "aaaa",
        // },
        // {
        //   id: "xxxxx",
        //   title: "aaaa",
        //   url: "aaaa",
        // },
        // {
        //   id: "xxxxx",
        //   title: "aaaa",
        //   url: "aaaa",
        // },
      ],
      jhimg: require("../../assets/images/jinhui.png"),
    };
  },
  mounted(){
    this.getdata();
  },
  methods: {
    getdata() {
      // let data = this.$qs.stringify({

      // });
      // console.log(data)
      this.$axios({
        method: "post",
        url: "/admin/kjhqt/hyperlink_list",
        // data: data
      })
        .then((res) => {
          if (res.data.code == 200) {
            // console.log(res)
            this.persondata = res.data.data;
          }
        })
        .catch((err) => {
          //this.$message.error(err);
        });
    },
  },
};
</script>

<style scoped lang="less">
.layout-footer {
  width: 100%;
  height: 226px;
  background: url("../../assets/images/botback.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;

  .layout-footer-warp {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    .jh {
      width: 10%;
      height: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      > img {
        width: 150px;
        height: 160px;
        margin: 0 auto;
      }
      //   background: url("../../assets/images/jinhui.png");
      //   background-repeat: no-repeat;
      //   background-size: 100% 100%;
    }
    .mt5 {
      width: 70%;
      height: 100%;
      overflow: hidden;
      > div {
        min-width: 300px;
        height: 50px;
        display: inline-block;
        line-height: 50px;
        text-align: left;

        
        margin: 10px 30px 0px 10px;
        color: white;
        .el-link.el-link--default {
          color: white;
        }
      }
      // >div:nth-child(even){
      //   margin-left: 20vw;
      // }
    }
  }
  //   &-warp {
  //     margin: auto;
  //     color: #9e9e9e;
  //     text-align: center;
  //   }
}
</style>
